import { http } from '@/lib/ats-https';

import type { FraudDetectorSettingsResponse } from '@/pages/settings/ats/FraudDetector/types';

/**
 * Contact background-verification (fraud detector) account settings service.
 *
 * Relocated here from `src/pages/settings/ats/FraudDetector/api.ts` so
 * cross-feature consumers (the ats-job-creation AI-teammates hooks) stop
 * importing into the settings page layer. The original module re-exports
 * this for within-feature callers.
 */
export const FRAUD_DETECTOR_API = {
  getSettings: async () => {
    try {
      const res = (await http.get(
        '/contact_background_verification/account_settings'
      )) as FraudDetectorSettingsResponse;
      return res?.data ?? { cbv_integration_enabled: false };
    } catch {
      return { cbv_integration_enabled: false };
    }
  },

  updateSettings: async (payload: { cbv_integration_enabled: boolean }) => {
    const res = (await http.put(
      '/contact_background_verification/account_settings',
      payload
    )) as FraudDetectorSettingsResponse;
    return res?.data ?? { cbv_integration_enabled: false };
  },
};
